export interface TooltipBox {
  left: number
  top: number
  width: number
  height: number
}

export interface TooltipPlacement {
  top: number
  left: number
  placement: 'below' | 'above' | 'float'
}

const GAP = 8
const MARGIN = 8
const FLOAT_TOP = 72

function clamp(value: number, min: number, max: number): number {
  if (max < min) return min
  return Math.min(max, Math.max(min, value))
}

/** Place a non-modal hint near an anchor. No anchor floats near the top of the viewport. */
export function placeTooltip(
  anchor: TooltipBox | null,
  popup: { width: number; height: number },
  viewport: { width: number; height: number },
): TooltipPlacement {
  const width = Math.max(0, popup.width)
  const height = Math.max(0, popup.height)
  const vw = viewport.width
  const vh = viewport.height

  if (!anchor || anchor.width <= 0 || anchor.height <= 0) {
    return {
      top: clamp(FLOAT_TOP, MARGIN, Math.max(MARGIN, vh - height - MARGIN)),
      left: clamp((vw - width) / 2, MARGIN, Math.max(MARGIN, vw - width - MARGIN)),
      placement: 'float',
    }
  }

  let left = anchor.left
  let top = anchor.top + anchor.height + GAP
  let placement: TooltipPlacement['placement'] = 'below'
  if (top + height > vh - MARGIN) {
    const above = anchor.top - GAP - height
    if (above >= MARGIN) {
      top = above
      placement = 'above'
    } else {
      top = Math.max(MARGIN, vh - MARGIN - height)
    }
  }
  if (left + width > vw - MARGIN) left = vw - MARGIN - width
  if (left < MARGIN) left = MARGIN
  return { top, left, placement }
}
